export enum ModelKey {
    TAOS = 'taos',
    GOLFGTI = 'golfgti',
    GOLFR = 'golfr',
    TIGUAN = 'tiguan',
    ATLAS = 'atlas',
    CROSSSPORT = 'atlascrosssport',
    JETTA = 'jetta',
    JETTAGLI = 'jettagli',
    ID4 = 'id4',
};